import { SettingUserIcon } from "./PrivateHeaderStyles.styled";
import { CloseButtonIcon, OpenMenuButtonIcon } from "./setIconStyles.styled";

export const SettingAccountUser = () => {
  return (
    <>
      <SettingUserIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 1.127l12.88 7.437v14.872l-12.88 7.437-12.88-7.437v-14.872l12.88-7.437zM16 4.207l-10.213 5.896v11.795l10.213 5.896 10.213-5.896v-11.795l-10.213-5.896zM16 12c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828 0.421 2.078 1.172 2.828c0.75 0.75 1.768 1.172 2.828 1.172s2.078-0.421 2.828-1.172c0.75-0.75 1.172-1.768 1.172-2.828s-0.421-2.078-1.172-2.828c-0.75-0.75-1.768-1.172-2.828-1.172zM9.334 16c0-1.768 0.702-3.464 1.953-4.714s2.946-1.953 4.714-1.953 3.464 0.702 4.714 1.953c1.25 1.25 1.953 2.946 1.953 4.714s-0.702 3.464-1.953 4.714c-1.25 1.25-2.946 1.953-4.714 1.953s-3.464-0.702-4.714-1.953c-1.25-1.25-1.953-2.946-1.953-4.714z" />
      </SettingUserIcon>
    </>
  );
};

export const CloseButtonMenuIcon = () => {
  return (
    <>
      <CloseButtonIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M16 17.867l-6.533 6.533c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933l6.533-6.533-6.533-6.533c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367l6.533 6.533 6.533-6.533c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933l-6.533 6.533 6.533 6.533c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367l-6.533-6.533z"
        ></path>
      </CloseButtonIcon>
    </>
  );
};

export const BurgerMobileMenu = () => {
  return (
    <>
      <OpenMenuButtonIcon
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#fff"
          d="M4.667 6.667c-0.354 0-0.693 0.14-0.943 0.391s-0.391 0.589-0.391 0.943c0 0.354 0.14 0.693 0.391 0.943s0.589 0.391 0.943 0.391h22.667c0.354 0 0.693-0.14 0.943-0.391s0.391-0.589 0.391-0.943c0-0.354-0.141-0.693-0.391-0.943s-0.589-0.391-0.943-0.391h-22.667zM3.333 16c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h22.667c0.354 0 0.693 0.141 0.943 0.391s0.391 0.589 0.391 0.943c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391h-22.667c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943zM3.333 24.001c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h22.667c0.354 0 0.693 0.141 0.943 0.391s0.391 0.589 0.391 0.943c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391h-22.667c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943z"
        ></path>
      </OpenMenuButtonIcon>
    </>
  );
};
